import { Component, Input, Output, EventEmitter, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbDialogService } from '@nebular/theme';

export interface FilterSettingsItem {
  key: string;
  label: string;
  visible: boolean;
  required?: boolean;
  active?: boolean;
}

@Component({
  selector: 'pv-filter-settings',
  templateUrl: './filter-settings.component.html',
  styleUrls: ['./filter-settings.component.scss']
})
export class FilterSettingsComponent implements OnInit {
  @Input() filters: FilterSettingsItem[] = [];
  @Input() storageKey: string = 'default';
  @Output() filtersChange = new EventEmitter<FilterSettingsItem[]>();
  @Output() visibilityChanged = new EventEmitter<FilterSettingsItem[]>();

  @ViewChild('filterSettingsModal', { static: true }) filterSettingsModal: TemplateRef<any>;

  constructor(private dialogService: NbDialogService) {}

  ngOnInit() {
    if (this.filters.length > 0) {
      this.loadFilterSettings();
    }
  }

  openModal() {
    this.dialogService.open(this.filterSettingsModal, {
      context: {
        filters: this.filters
      },
      closeOnBackdropClick: true,
      closeOnEsc: true
    });
  }

  toggleFilter(filter: FilterSettingsItem) {
    if (!filter.required && !filter.active) {
      filter.visible = !filter.visible;
      this.updateSettings();
    }
  }

  showAllFilters() {
    this.filters.forEach(filter => {
      if (!filter.active) {
        filter.visible = true;
      }
    });
    this.updateSettings();
  }

  hideAllFilters() {
    this.filters.forEach(filter => {
      if (!filter.required && !filter.active) {
        filter.visible = false;
      }
    });
    this.updateSettings();
  }

  private updateSettings() {
    this.saveFilterSettings();
    this.emitChanges();
  }

  private emitChanges() {
    this.filtersChange.emit(this.filters);
    this.visibilityChanged.emit(this.filters);
  }

  private saveFilterSettings() {
    const storageKey = this.getStorageKey();
    const settings = this.filters.map(col => ({
      key: col.key,
      visible: col.visible
    }));
    localStorage.setItem(storageKey, JSON.stringify(settings));
  }

  private loadFilterSettings() {
    const storageKey = this.getStorageKey();
    const saved = localStorage.getItem(storageKey);
    
    if (saved) {
      try {
        const settings = JSON.parse(saved);
        this.applySettings(settings);
        this.emitChanges();
      } catch (e) {
        console.warn('Failed to load filter settings:', e);
      }
    }
  }

  private applySettings(settings: any[]) {
    settings.forEach(setting => {
      const filter = this.filters.find(col => col.key === setting.key);
      if (filter) {
        filter.visible = setting.visible;
      }
    });
  }

  private getStorageKey(): string {
    return `filterSettings_${this.storageKey}`;
  }
}
